<template>
  <div class="w-100">
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <div v-else-if="allAnreden.length">
      <v-btn
        class="float-right"
        color="success"
        flat
        title="Neue Anrede erfassen"
        @click="createAnreden"
      >
        <i class="fas fa-plus mr-3" /> Erfassen
      </v-btn>

      <div class="col-4">
        <v-text-field
          id="searchInput"
          v-model="searchTerm"
          append-icon="fas fa-search"
          class="search--input"
          label="Nach Anrede suchen..."
        />
      </div>
      <table class="w-100 anredenOverview ml-2 mt-5">
        <thead>
          <tr>
            <th>Anrede</th>
            <th>Briefanrede</th>
            <th>Aktion</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="anrede in filteredAnreden"
            :key="anrede.id"
          >
            <td>{{ anrede.value }}</td>
            <td>{{ anrede.letterFormOfAddress }}</td>
            <td>
              <v-btn
                color="#007bff"
                dark
                fab
                small
                title="Bearbeiten"
                @click="editAnreden(anrede.formOfAddressId)"
              >
                <i class="fas fa-edit" />
              </v-btn>
              <v-btn
                color="#e72b37"
                dark
                fab
                small
                title="Löschen"
                @click="deleteAnreden(anrede.formOfAddressId)"
              >
                <i class="fas fa-trash" />
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <v-btn
        color="success"
        title="Neue Anrede erfassen"
        @click="createAnreden"
      >
        <i class="fas fa-plus mr-3" /> Neue Anrede Erfassen
      </v-btn>
    </div>
  </div>
</template>

<script>
import {
  DeleteFormOfAddress,
  GetFormOfAddress,
} from "@/services/user.crm.service.js";

export default {
  data() {
    return {
      isLoading: false,
      errorObject: null,
      searchTerm: "",
      allAnreden: [],
      filteredAnreden: [],
    };
  },
  watch: {
    searchTerm() {
      this.filterAnreden();
    },
  },
  created() {
    if (this.$route.path === "/anrede") {
      this.getFormOfAddress();
    }
  },
  methods: {
    getFormOfAddress() {
      this.isLoading = true;
      this.errorObject = null;

      GetFormOfAddress(
        (response) => {
          this.filteredAnreden = response;
          this.allAnreden = response;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    filterAnreden() {
      if (this.searchTerm) {
        this.filteredAnreden = this.allAnreden.filter((anrede) => {
          let value = anrede.value.toLowerCase();
          let letterFormOfAddress = anrede.letterFormOfAddress.toLowerCase();
          let search = this.searchTerm.toLowerCase();

          return value.includes(search) || letterFormOfAddress.includes(search);
        });
      } else {
        this.filteredAnreden = this.allAnreden;
      }
    },
    createAnreden() {
      this.$router.push({
        path: "anrede/create",
      });
    },
    editAnreden(formOfAddressId) {
      this.$router.push({
        path: "anrede/edit?anrede=" + formOfAddressId,
      });
    },
    deleteAnreden(formOfAddressId) {
      this.isLoading = true;
      DeleteFormOfAddress(
        formOfAddressId,
        () => {
          this.getFormOfAddress();
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style scoped>
.anredenOverview {
  font-size: small;
  table-layout: fixed;
}

.anredenOverview thead th:nth-child(1) {
  width: 10%;
}

.anredenOverview thead th:nth-child(2) {
  width: 20%;
}

.anredenOverview thead th:nth-child(3) {
  width: 5%;
}

.anredenOverview tbody tr {
  border-bottom: 1px solid gainsboro;
}

.anredenOverview td,
.anredenOverview th {
  padding: 8px 4px;
}
</style>
